import React from "react";
import { motion } from "framer-motion";
import visionImage from '../Images/5147393.png'; // Add your vision image
import missionImage from '../Images/2376627.png';
import { AppConstant } from "../AppConstant";

const CompanyOverview = () => {

  const containerVariants = {
    hiddenLeft: { opacity: 0, x: -100 },
    hiddenRight: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, type: "spring" } },
  };
  // utility function
  const toSentenceCase = (str) => {
    return str
      .toLowerCase()
      .replace(/(^\s*\w|[.!?]\s*\w)/g, (c) => c.toUpperCase());
  };

  return (
    < >
      <div style={styles.container}>
        {/* Company Overview */}
        <div style={styles.section}>


          <motion.h2
            style={{ color: "#0A1733", fontSize: '60px', textAlign: 'center' }}
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Company<span style={{ color: '#f37021' }}> Overview</span>
          </motion.h2>

          <p style={styles.paragraph}>
            <strong>
              <em>
                StructGuard Engineers LLP, Established in 2019 and headquartered in INDIA.
              </em>
            </strong>{" "}
            StructGuard is a leading structural engineering consultancy specializing in the delivery of high-performance design, analysis, and detailing solutions for steel, cold-formed steel, lumber, aluminum, precast, concrete and special structure firm also offers advanced specialty design services including staircases, railings, rooftop curbs, solar panel support systems, sign board, sculptures, tilt-up and sandwich wall panels, as well as machine foundations. with strategic collaborations involving licensed professional engineers across more than 35 USA states, StructGuard ensures global code compliance and engineering excellence while utilizing industry-leading software platforms such as ETABS, SAP2000, STAAD, Tekla, and Revit. The firm’s expertise spans international standards and building codes including ASCE, AISC, ACI, PCI, and IBC, enabling StructGuard to successfully execute projects across diverse sectors such as industrial, residential, healthcare, aviation, and commercial infrastructure driven by its mission to be one of the most innovative and trusted structural engineering firms worldwide, StructGuard prioritizes technical accuracy, adaptability, quality assurance, and timely project delivery. The company is dedicated to fostering long-term partnerships built on trust, precision, efficiency, and performance excellence.
          </p>
        </div>

      </div>

      <div style={styles.containermndv} >
        {/* Mission */}
        <motion.div
          style={styles.missionWrapper}
          initial="hiddenLeft"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          variants={containerVariants}
        >
          <div style={styles.visionContainer}>

            <div style={styles.missiondarkBox}>

              <h3 style={styles.darkHeading}>Mission</h3>

              <p style={{ fontSize: '18px',  wordSpacing: "8px" }}>
                The mission of {" "}
                <em>
                  StructGuard Engineers LLP
                </em>{" "} is to deliver world-class engineering and detailing services that not only meet but exceed client expectations. The firm is dedicated to providing precise, reliable, and cost-effective structural solutions, ensuring safety, efficiency, and durability in every project. With a focus on innovation and adaptability, StructGuard continuously embraces advanced technologies, modern software tools, and international codes to stay ahead in the field of structural engineering. Beyond technical excellence, the company’s mission emphasises client-centricity—offering flexibility in pricing, prompt responses, and personalised solutions to align with diverse project needs and budgets. StructGuard is committed to nurturing long-term relationships, built on trust, transparency, and consistent quality, positioning itself as a dependable partner for industrial, residential, healthcare, aviation, and commercial sectors across INDIA, the Middle East, and the USA.
              </p>

            </div>

            <div style={styles.visionImageWrapper}>
              <img src={missionImage} alt="Mission" style={styles.visionImage} />
            </div>

          </div>
        </motion.div>




        {/* Vision */}
        <motion.div
          style={styles.visionWrapper}
          initial="hiddenRight"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          variants={containerVariants}
        >
          <div style={styles.visionContainer}>

            <div style={styles.visionImageWrapper}>
              <img src={visionImage} alt="Vision" style={styles.visionImage} />
            </div>

            <div style={styles.VisiondarkBox}>

              <h3 style={styles.darkHeading}>Vision</h3>

              <p style={{ fontSize: '18px',  }}>
                <em>
                  StructGuard Engineers LLP
                </em>{" "}
                envisions becoming a globally recognised and trusted structural engineering firm, known not only for its innovative solutions but also for its uncompromising commitment to quality, safety, and sustainability. The company strives to set new benchmarks in engineering excellence, leveraging cutting-edge technology, international design standards, and deep technical expertise to deliver solutions that stand the test of time. Its long-term vision is to foster enduring partnerships with clients worldwide, guided by core values of quality, persistence, productivity, performance, and punctuality. StructGuard aspires to play a pivotal role in shaping infrastructure and architectural development across industries, contributing to projects that impact communities positively while maintaining environmental responsibility.
              </p>

            </div>

          </div>

        </motion.div>

      </div>
    </>
  );
};

const styles = {
  container: {
    padding: '4rem 2rem',
    fontFamily: 'Arial, sans-serif',
    // backgroundColor: 'white',
    // backgroundImage: AppConstant.backgroundtextilerdesign,
    // backgroundAttachment: AppConstant.backgroundAttachmentscroller,
    color: '#333',
    lineHeight: '1.6',

  },
  containermndv: {
    backgroundColor: 'white',
    // backgroundImage: AppConstant.backgroundtextilerdesign,
    backgroundAttachment: AppConstant.backgroundAttachmentscroller,

    color: '#333',
    lineHeight: '1.6',
  },
  section: {
    marginBottom: '3rem',
    maxWidth: '100%',
  },
  heading: {
    fontSize: '60px',
    fontWeight: 'bold',
    color: "#0A1733"
  },
  orangeText: {
    color: '#f37021',
  },
  paragraph: {
    fontSize: '21px',
    // marginTop: '1rem',
    color: "#0A1733",
    // textTransform: "capitalize",
    // fontWeight: '700'
    // width:'90%'
  

  },
  missionWrapper: {
    display: 'flex',
    justifyContent: 'flex-start', // 👈 moves to right
    marginBottom: '3rem',
  },
  missiondarkBox: {

    // background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
    color: '#070707ff',
    padding: '2rem',
    borderRadius: '0 2rem 2rem 0 ',
    maxWidth: '800px',
    textAlign: 'left',
    background: 'white',
    // background: 'linear-gradient(145deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
    borderTop: '4px solid #f37021',
    borderRight: '4px solid #f37021',
    borderBottom: '4px solid #f37021',
    // borderRight: 'none',  // 🚀 removes right side border
    boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
    backdropFilter: 'blur(8px)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },

  // Vision box only
  visionWrapper: {
    display: 'flex',
    justifyContent: 'flex-end', // 👈 moves to right

  },
  visionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '2rem',
    flexWrap: 'wrap', // ensures responsiveness
    // background: 'white',
  },
  visionImageWrapper: {
    flex: '1 1 300px',
    textAlign: 'center',
  },
  visionImage: {
    // maxWidth: '100%',
    // height: 'auto',
    // borderRadius: '1rem',

    width: '100%',       // takes full width of wrapper
    maxWidth: '400px',   // optional: limit max size on larger screens
    height: 'auto',
    borderRadius: '1rem',
  },

  VisiondarkBox: {


    color: '#070707ff',
    background: 'white',
    padding: '2rem',
    borderRadius: '2rem 0 0 2rem',
    maxWidth: '800px',
    textAlign: 'left',

    borderTop: '4px solid #f37021',
    borderLeft: '4px solid #f37021',
    borderBottom: '4px solid #f37021',
    borderRight: 'none',  // 🚀 removes right side border
    boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
    backdropFilter: 'blur(8px)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  darkHeading: {
    color: '#f37021',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
    textAlign: 'left'
  },
};

export default CompanyOverview;







// import React from "react";
// import {
//   ComposableMap,
//   Geographies,
//   Geography,
// } from "react-simple-maps";

// // USA states topojson
// const geoUrl =
//   "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

// // List of states where your company works
// const highlightedStates = [
//   "Ohio", "Kentucky", "Indiana", "Michigan", "Nebraska", "Pennsylvania",
//   "South Carolina", "Tennessee", "Oklahoma", "Washington", "Virginia", "Florida",
//   "Texas", "West Virginia", "Missouri", "Arizona", "Louisiana", "Illinois",
//   "Maryland", "Arkansas", "New York", "New Mexico", "Kansas", "Oregon",
//   "Georgia", "Minnesota", "North Carolina", "Iowa", "Connecticut", "Colorado",
//   "Wisconsin", "New Hampshire", "Nevada", "Mississippi", "North Dakota", "Montana"
// ];

// export default function USAMap() {
//   return (
//     <div
//       style={{
//         width: "100vw",
//         height: "100vh",
//         backgroundColor: "#f0f8ff", // light ocean bg
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//     >
//       <ComposableMap
//         projection="geoAlbersUsa"
//         projectionConfig={{ scale: 1000 }}
//         style={{ width: "100%", height: "100%" }}
//       >
//         <Geographies geography={geoUrl}>
//           {({ geographies }) =>
//             geographies.map((geo) => {
//               const isHighlighted = highlightedStates.includes(
//                 geo.properties.name
//               );
//               return (
//                 <Geography
//                   key={geo.rsmKey}
//                   geography={geo}
//                   style={{
//                     default: {
//                       fill: isHighlighted ? "orange" : "#EEE",
//                       stroke: "blue",
//                       strokeWidth: 0.6,
//                       outline: "none",
//                     },
//                     hover: {
//                       fill: isHighlighted ? "#ff9933" : "#DDD",
//                       stroke: "blue",
//                       strokeWidth: 0.8,
//                       outline: "none",
//                     },
//                     pressed: {
//                       fill: "#ff6600",
//                       stroke: "#0033cc",
//                       outline: "none",
//                     },
//                   }}
//                 />
//               );
//             })
//           }
//         </Geographies>
//       </ComposableMap>
//     </div>
//   );
// }













// import React from "react";
// import {
//   ComposableMap,
//   Geographies,
//   Geography,
//   Marker,
// } from "react-simple-maps";

// const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

// // List of states with coordinates for labels
// const statesWithCoordinates = [
//   { name: "Ohio", coordinates: [-82.9071, 40.4173] },
//   { name: "Kentucky", coordinates: [-84.2700, 37.8393] },
//   { name: "Indiana", coordinates: [-86.1349, 40.2672] },
//   { name: "Michigan", coordinates: [-85.6024, 44.3148] },
//   { name: "Nebraska", coordinates: [-99.9018, 41.4925] },
//   { name: "Pennsylvania", coordinates: [-77.1945, 41.2033] },
//   { name: "South Carolina", coordinates: [-80.9450, 33.8361] },
//   { name: "Tennessee", coordinates: [-86.5804, 35.5175] },
//   { name: "Oklahoma", coordinates: [-97.0929, 35.0078] },
//   { name: "Washington", coordinates: [-120.7401, 47.7511] },
//   { name: "Virginia", coordinates: [-78.6569, 37.4316] },
//   { name: "Florida", coordinates: [-81.5158, 27.6648] },
//   { name: "Texas", coordinates: [-99.9018, 31.9686] },
//   { name: "West Virginia", coordinates: [-80.4549, 38.5976] },
//   { name: "Missouri", coordinates: [-91.8318, 37.9643] },
//   { name: "Arizona", coordinates: [-111.0937, 34.0489] },
//   { name: "Louisiana", coordinates: [-92.3291, 30.9843] },
//   { name: "Illinois", coordinates: [-89.3985, 40.6331] },
//   { name: "Maryland", coordinates: [-76.6413, 39.0458] },
//   { name: "Arkansas", coordinates: [-92.2896, 35.2010] },
//   { name: "New York", coordinates: [-75.4999, 43.0000] },
//   { name: "New Mexico", coordinates: [-105.8701, 34.5199] },
//   { name: "Kansas", coordinates: [-98.4842, 39.0119] },
//   { name: "Oregon", coordinates: [-120.5542, 43.8041] },
//   { name: "Georgia", coordinates: [-82.9001, 32.1656] },
//   { name: "Minnesota", coordinates: [-94.6859, 46.7296] },
//   { name: "North Carolina", coordinates: [-79.0193, 35.7596] },
//   { name: "Iowa", coordinates: [-93.0977, 42.0329] },
//   { name: "Connecticut", coordinates: [-72.7554, 41.6032] },
//   { name: "Colorado", coordinates: [-105.7821, 39.5501] },
//   { name: "Wisconsin", coordinates: [-88.7879, 43.7844] },
//   { name: "New Hampshire", coordinates: [-71.5724, 43.1939] },
//   { name: "Nevada", coordinates: [-116.4194, 38.8026] },
//   { name: "Mississippi", coordinates: [-89.6787, 32.3547] },
//   { name: "North Dakota", coordinates: [-100.4659, 47.5515] },
//   { name: "Montana", coordinates: [-110.3626, 46.8797] },
// ];

// export default function USAMapWithSidePanel() {
//   return (
//     <div
//       style={{
//         display: "flex",
//         width: "100vw",
//         height: "100vh",
//         backgroundColor: "#f0f8ff",
//       }}
//     >
//       {/* Map Section */}
//       <div style={{ flex: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
//         <ComposableMap
//           projection="geoAlbersUsa"
//           projectionConfig={{ scale: 1000 }}
//           style={{ width: "90%", height: "90%" }}
//         >
//           <Geographies geography={geoUrl}>
//             {({ geographies }) =>
//               geographies.map((geo) => {
//                 const isHighlighted = statesWithCoordinates.some(
//                   (s) => s.name === geo.properties.name
//                 );
//                 return (
//                   <Geography
//                     key={geo.rsmKey}
//                     geography={geo}
//                     style={{
//                       default: {
//                         fill: isHighlighted ? "orange" : "#EEE",
//                         stroke: "blue",
//                         strokeWidth: 0.6,
//                         outline: "none",
//                       },
//                       hover: {
//                         fill: isHighlighted ? "#ff9933" : "#DDD",
//                         stroke: "blue",
//                         strokeWidth: 0.8,
//                         outline: "none",
//                       },
//                       pressed: {
//                         fill: "#ff6600",
//                         stroke: "#0033cc",
//                         outline: "none",
//                       },
//                     }}
//                   />
//                 );
//               })
//             }
//           </Geographies>

//           {statesWithCoordinates.map(({ name, coordinates }) => (
//             <Marker key={name} coordinates={coordinates}>
//               <text
//                 textAnchor="middle"
//                 style={{ fontFamily: "system-ui", fill: "black", fontSize: 10 }}
//               >
//                 {name}
//               </text>
//             </Marker>
//           ))}
//         </ComposableMap>
//       </div>

//       {/* Side Panel */}
//       <div
//         style={{
//           flex: 1,
//           padding: "20px",
//           backgroundColor: "#ffffff",
//           boxShadow: "0px 0px 15px rgba(0,0,0,0.1)",
//           overflowY: "auto",
//         }}
//       >
//         <h2 style={{ color: "#333", marginBottom: "15px" }}>
//           States We Operate In
//         </h2>
//         <p style={{ marginBottom: "20px" }}>
//           Our company has successfully completed projects in the following US states:
//         </p>
//         <ul>
//           {statesWithCoordinates.map((s) => (
//             <li key={s.name} style={{ marginBottom: "5px" }}>
//               {s.name}
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// }
